import login from './messages/login'
import $vuetify from './messages/vuetify'

export default {
  ...login,
  ...$vuetify,
}
